(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quote-wizard"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const wizard = document.querySelector('.quote-wizard');
    if (!wizard) return;

    const form = wizard.querySelector('.quote-wizard__form');
    const steps = wizard.querySelectorAll('.wizard-step');
    const progressSteps = wizard.querySelectorAll('.progress-step');
    const progressBar = wizard.querySelector('.progress-bar__fill');
    const backBtn = wizard.querySelector('.wizard-btn--back');
    const nextBtn = wizard.querySelector('.wizard-btn--next');
    const submitBtn = wizard.querySelector('.wizard-btn--submit');
    const successDiv = wizard.querySelector('.wizard-success');
    const reviewSections = wizard.querySelectorAll('.review-section');

    let currentStep = 1;
    const totalSteps = steps.length;

    // Initialize from URL params (prefill from home page)
    function initFromUrlParams() {
      const params = new URLSearchParams(window.location.search);

      const mappings = {
        'name': (value) => {
          const parts = value.split(' ');
          const firstName = document.getElementById('first_name');
          const lastName = document.getElementById('last_name');
          if (firstName && parts[0]) firstName.value = parts[0];
          if (lastName && parts.slice(1).join(' ')) lastName.value = parts.slice(1).join(' ');
        },
        'email': (value) => {
          const el = document.getElementById('email');
          if (el) el.value = value;
        },
        'message': (value) => {
          const el = document.getElementById('application_comments');
          if (el) el.value = value;
        }
      };

      params.forEach((value, key) => {
        if (mappings[key]) {
          mappings[key](value);
        } else {
          const el = document.getElementById(key);
          if (el) el.value = value;
        }
      });
    }

    // Update progress indicator
    function updateProgress() {
      const progress = (currentStep / totalSteps) * 100;
      progressBar.style.width = `${progress}%`;

      progressSteps.forEach((step, index) => {
        const stepNum = index + 1;
        step.classList.remove('active', 'completed');

        if (stepNum < currentStep) {
          step.classList.add('completed');
        } else if (stepNum === currentStep) {
          step.classList.add('active');
        }
      });
    }

    // Show specific step
    function showStep(stepNumber) {
      steps.forEach(step => step.classList.remove('active'));
      const targetStep = wizard.querySelector(`.wizard-step[data-step="${stepNumber}"]`);
      if (targetStep) {
        targetStep.classList.add('active');
        targetStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Update buttons
      backBtn.disabled = stepNumber === 1;

      if (stepNumber === totalSteps) {
        nextBtn.style.display = 'none';
        submitBtn.style.display = 'inline-flex';
        updateReviewSection();
      } else {
        nextBtn.style.display = 'inline-flex';
        submitBtn.style.display = 'none';
      }

      currentStep = stepNumber;
      updateProgress();
    }

    // Validate current step
    function validateStep(stepNumber) {
      const step = wizard.querySelector(`.wizard-step[data-step="${stepNumber}"]`);
      const requiredFields = step.querySelectorAll('[required]');
      let isValid = true;

      requiredFields.forEach(field => {
        const errorSpan = field.parentElement.querySelector('.field-error');

        if (!field.value.trim()) {
          field.classList.add('error');
          if (errorSpan) errorSpan.textContent = 'This field is required';
          isValid = false;
        } else if (field.type === 'email' && !isValidEmail(field.value)) {
          field.classList.add('error');
          if (errorSpan) errorSpan.textContent = 'Please enter a valid email';
          isValid = false;
        } else {
          field.classList.remove('error');
          if (errorSpan) errorSpan.textContent = '';
        }
      });

      // Check radio groups
      const radioGroups = step.querySelectorAll('[required][type="radio"]');
      const checkedGroups = new Set();
      radioGroups.forEach(radio => {
        if (radio.checked) checkedGroups.add(radio.name);
      });

      radioGroups.forEach(radio => {
        if (!checkedGroups.has(radio.name)) {
          const container = radio.closest('.form-field');
          const errorSpan = container?.querySelector('.field-error');
          if (errorSpan) errorSpan.textContent = 'Please select an option';
          isValid = false;
        }
      });

      return isValid;
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    // Conditional field visibility
    function setupConditionalFields() {
      const conditionalGroups = wizard.querySelectorAll('.form-conditional');

      conditionalGroups.forEach(group => {
        const fieldName = group.dataset.showWhen;
        const showValue = group.dataset.showValue;

        const inputs = wizard.querySelectorAll(`[name="${fieldName}"]`);
        inputs.forEach(input => {
          input.addEventListener('change', () => {
            const selectedValue = wizard.querySelector(`[name="${fieldName}"]:checked`)?.value;
            if (selectedValue === showValue) {
              group.classList.add('visible');
            } else {
              group.classList.remove('visible');
            }
          });
        });
      });
    }

    // Update review section
    function updateReviewSection() {
      // Contact Info
      const contactHtml = `
        <div class="review-item">
          <span class="review-item__label">Name</span>
          <span class="review-item__value">${getValue('first_name')} ${getValue('last_name')}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Email</span>
          <span class="review-item__value">${getValue('email')}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Phone</span>
          <span class="review-item__value">${getValue('phone')}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Company</span>
          <span class="review-item__value">${getValue('company')}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Address</span>
          <span class="review-item__value">${getValue('address1')}${getValue('address2') ? ', ' + getValue('address2') : ''}, ${getValue('city')}, ${getValue('state')} ${getValue('zip')}, ${getSelectText('country')}</span>
        </div>
      `;
      document.getElementById('review-contact').innerHTML = contactHtml;

      // Formation
      const formationType = wizard.querySelector('[name="formation_type"]:checked')?.value || 'Not specified';
      let dimensionsHtml = '';
      if (formationType === 'tubular') {
        dimensionsHtml = `OD: ${getValue('tubular_od') || 'N/A'}, Length: ${getValue('tubular_length') || 'N/A'}`;
      } else if (formationType === 'rectangular') {
        dimensionsHtml = `Length: ${getValue('rect_length') || 'N/A'}, Height: ${getValue('rect_height') || 'N/A'}`;
      } else if (formationType === 'other') {
        dimensionsHtml = getValue('other_dimensions') || 'Not specified';
      }

      const formationHtml = `
        <div class="review-item">
          <span class="review-item__label">Tape Width</span>
          <span class="review-item__value">${getValue('tape_width') || 'Not specified'}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Formation Type</span>
          <span class="review-item__value">${capitalizeFirst(formationType)}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Dimensions</span>
          <span class="review-item__value">${dimensionsHtml}</span>
        </div>
      `;
      document.getElementById('review-formation').innerHTML = formationHtml;

      // Specifications
      const materials = Array.from(wizard.querySelectorAll('[name="construction_material[]"]:checked'))
        .map(el => capitalizeFirst(el.value)).join(', ') || 'Not specified';

      const specsHtml = `
        <div class="review-item">
          <span class="review-item__label">Construction Material</span>
          <span class="review-item__value">${materials}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Temperature</span>
          <span class="review-item__value">Maint: ${getValue('maintenance_temp') || 'N/A'}, Op: ${getValue('operating_temp') || 'N/A'}, Max: ${getValue('max_operating_temp') || 'N/A'}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Electrical</span>
          <span class="review-item__value">${getValue('watts_required') || 'N/A'} W, ${getSelectText('supply_voltage') || 'N/A'}, ${getSelectText('phase') || 'N/A'}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Location</span>
          <span class="review-item__value">${capitalizeFirst(getRadioValue('location') || 'Not specified')}, Moisture: ${capitalizeFirst(getRadioValue('moisture_present') || 'N/A')}</span>
        </div>
      `;
      document.getElementById('review-specifications').innerHTML = specsHtml;

      // Features
      const controls = Array.from(wizard.querySelectorAll('[name="optional_controls[]"]:checked'))
        .map(el => el.value.replace(/_/g, ' ')).join(', ') || 'None';

      const featuresHtml = `
        <div class="review-item">
          <span class="review-item__label">Sensor Type</span>
          <span class="review-item__value">${getSelectText('sensor_type') || 'Not specified'}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">End Caps</span>
          <span class="review-item__value">${capitalizeFirst(getRadioValue('end_caps') || 'None')}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Temperature Control</span>
          <span class="review-item__value">${getSelectText('temperature_control') || 'Not specified'}</span>
        </div>
        <div class="review-item">
          <span class="review-item__label">Optional Controls</span>
          <span class="review-item__value">${capitalizeFirst(controls)}</span>
        </div>
      `;
      document.getElementById('review-features').innerHTML = featuresHtml;
    }

    function getValue(id) {
      const el = document.getElementById(id);
      return el ? el.value : '';
    }

    function getSelectText(id) {
      const el = document.getElementById(id);
      return el ? el.options[el.selectedIndex]?.text : '';
    }

    function getRadioValue(name) {
      const el = wizard.querySelector(`[name="${name}"]:checked`);
      return el ? el.value : '';
    }

    function capitalizeFirst(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    // Event Listeners
    backBtn.addEventListener('click', () => {
      if (currentStep > 1) {
        showStep(currentStep - 1);
      }
    });

    nextBtn.addEventListener('click', () => {
      if (validateStep(currentStep) && currentStep < totalSteps) {
        showStep(currentStep + 1);
      }
    });

    // Edit button handlers
    reviewSections.forEach(section => {
      const editBtn = section.querySelector('.review-section__edit');
      if (editBtn) {
        editBtn.addEventListener('click', () => {
          const targetStep = parseInt(section.dataset.editStep);
          if (targetStep) showStep(targetStep);
        });
      }
    });

    // Form submission
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (!validateStep(currentStep)) return;

      // Show loading state
      submitBtn.disabled = true;
      submitBtn.querySelector('span').textContent = 'Submitting...';

      // Generate reference number
      const refNum = 'QR-' + new Date().getFullYear() + '-' + Math.random().toString(36).substr(2, 5).toUpperCase();

      // Simulate form submission (replace with actual submission logic)
      setTimeout(() => {
        form.style.display = 'none';
        wizard.querySelector('.wizard-navigation').style.display = 'none';
        wizard.querySelector('.quote-wizard__progress').style.display = 'none';
        document.getElementById('reference-number').textContent = refNum;
        successDiv.style.display = 'block';
        successDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 1500);
    });

    // Clear errors on input
    form.addEventListener('input', (e) => {
      const field = e.target;
      if (field.classList.contains('error')) {
        field.classList.remove('error');
        const errorSpan = field.parentElement.querySelector('.field-error');
        if (errorSpan) errorSpan.textContent = '';
      }
    });

    // Initialize
    initFromUrlParams();
    setupConditionalFields();
    showStep(1);
  })();

  } catch(e) { console.error(e); }
})();
})();
